import addDays from "date-fns/addDays";
import format from "date-fns/format";
import { useSearchParams } from "next/navigation";
import React, { useContext, useEffect, useState } from "react";

export const HomeContext = React.createContext(null);

export const start = new Date();
export const end = addDays(start, 5);

// eslint-disable-next-line react/display-name
const HomeProvider = ({ children }) => {
  const searchParams = useSearchParams();

  const initialFilterForm = {
    start: format(start, "yyyy-MM-dd"),
    end: format(end, "yyyy-MM-dd"),
    yetiskin: 1,
    cocuk: 0,
    tip: [],
    bolge: [],
    min: "",
    max: "",
  };

  const [filterForm, setFilterForm] = useState(initialFilterForm);
  const [selectedDatesFilter, setSelectedDatesFilter] = useState([
    {
      startDate: start,
      endDate: new Date(end),
      key: "selection",
      isShow: 0,
    },
  ]);
  const [minPriceBase, setMinPriceBase] = useState(0);
  const [maxPriceBase, setMaxPriceBase] = useState(1000000);

  useEffect(() => {
    setFilterForm((prev) => ({
      ...prev,
      start: searchParams.get("start") || format(start, "yyyy-MM-dd"),
      end: searchParams.get("end") || format(end, "yyyy-MM-dd"),
      yetiskin: parseInt(searchParams.get("yetiskin")) || 1,
      cocuk: parseInt(searchParams.get("cocuk")) || 0,
      min: searchParams.get("min") ? parseInt(searchParams.get("min")) : "",
      max: searchParams.get("max") ? parseInt(searchParams.get("max")) : "",
    }));

    setSelectedDatesFilter([
      {
        startDate: searchParams.get("start")
          ? new Date(searchParams.get("start"))
          : start,
        endDate: searchParams.get("end")
          ? new Date(searchParams.get("end"))
          : end,
        key: "selection",
        isShow: 0,
      },
    ]);
  }, [searchParams]);

  const value = {
    filterForm,
    setFilterForm,
    selectedDatesFilter,
    setSelectedDatesFilter,
    minPriceBase,
    setMinPriceBase,
    maxPriceBase,
    setMaxPriceBase,
  };

  return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>;
};

export default HomeProvider;

export function useHomeContext() {
  const context = useContext(HomeContext);
  if (!context) {
    throw new Error(
      "useStoreContext bir StoreContextProvider içinde kullanılmalıdır"
    );
  }
  return context;
}
